
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ConnectionErrorAlertProps {
  connectionError: string | null;
  onRetryConnection: () => void;
  onContinueOffline: () => void;
}

const ConnectionErrorAlert = ({
  connectionError,
  onRetryConnection,
  onContinueOffline
}: ConnectionErrorAlertProps) => {
  return (
    <Alert variant="destructive" className="mb-6">
      <AlertTriangle className="h-5 w-5" />
      <AlertTitle className="text-lg font-semibold mb-2">Lỗi kết nối đến cơ sở dữ liệu</AlertTitle>
      <AlertDescription className="space-y-4">
        <p>{connectionError || 'Không thể kết nối đến cơ sở dữ liệu. Vui lòng thử lại sau.'}</p>
        
        <div className="flex flex-wrap gap-3 mt-2">
          <Button 
            variant="outline" 
            size="sm" 
            className="bg-white hover:bg-gray-100"
            onClick={onRetryConnection}
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Thử kết nối lại
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            className="bg-white hover:bg-gray-100"
            onClick={onContinueOffline}
          >
            Tiếp tục ngoại tuyến
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  );
};

export default ConnectionErrorAlert;
